import React from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Auth from './pages/Auth/Auth';
import Upload from './pages/Upload/Upload';
import LoginPage from './pages/LoginPage/LoginPage';
import UserManagement from './pages/UserManagement/Home';
import ActivityReport from './pages/Report/ActivityReport';
import Language from './pages/Language/language';
import { Container, Row, Col } from 'react-bootstrap';
// import Sidebar from './Sidebar';
// import Dashboard from './Dashboard';
// import Profile from './Profile';
// import Settings from './Settings';
// import Logout from './Logout';
// import Login from './Login';

const Layout = () => {
  const location = useLocation();

  // Check if the current path is "login"
  const isLoginPage = location.pathname === '/';

  return (
    <Container fluid>
    <Row>
      {/* Conditionally render Sidebar */}
      {!isLoginPage && (
        <Col xs={12} md={3} lg={2} className="p-0">
          <Sidebar />
        </Col>
      )}
      <Col
        xs={12} 
        md={9} 
        lg={10} 
        className="main-content p-3"
        style={{
          marginLeft: isLoginPage ? '0' : 'auto', // Adjust margin based on login page
        }}
      >
        <Routes>
          <Route path='/' element={<Auth/>}/>
          <Route path='/upload-books' element={<Upload/>}/>
          <Route path='/upload-user' element={<UserManagement/>}/>
          <Route path='/activity-report' element={<ActivityReport/>}/>
          <Route path='/languages' element={<Language/>}/>
        </Routes>
      </Col>
    </Row>
  </Container>
  );
};

export default Layout